import {FC} from 'react';

import HappyVegIcon from '@stencil/icons/src/HappyVegIcon/HappyVegIcon';
import HappyTimerNewIcon from '@stencil/icons/src/HappyTimerNewIcon/HappyTimerNewIcon';
import HappyMenuNewIcon from '@stencil/icons/src/HappyMenuNewIcon/HappyMenuNewIcon';
import HappyRupeeCircularNewIcon from '@stencil/icons/src/HappyRupeeCircularNewIcon/HappyRupeeCircularNewIcon';

import {getIconFromName} from '@stencil/hotels-utils/src/name-to-icon-map-food';
import {isObjectEmpty} from '@stencil/hotels-utils/src/common-utils';

import * as S from './DiningDetailsUI.styles';

interface DiningDetailsUIProps {
  timings: any;
  avgMealCost: any;
  cuisines: any;
  foodType: any;
}

const DiningDetailsUI: FC<DiningDetailsUIProps> = ({avgMealCost, cuisines, timings, foodType}) => {
  if (
    (!foodType ||
      isObjectEmpty(foodType) ||
      (foodType?.icon?.length === 0 && foodType?.text?.length === 0)) &&
    (!timings ||
      isObjectEmpty(timings) ||
      (timings?.icon?.length === 0 && timings?.text?.length === 0)) &&
    (!avgMealCost ||
      isObjectEmpty(avgMealCost) ||
      (avgMealCost?.icon?.length === 0 && avgMealCost?.text?.length === 0)) &&
    (!cuisines ||
      isObjectEmpty(cuisines) ||
      (cuisines?.icon?.length === 0 && cuisines?.text?.length === 0))
  )
    return null;

  const is24HourFoodAvailiable = timings?.icon === 'ic_24hr_time';

  return (
    <>
      <S.DiningWrapper>
        <S.FirstFullContainer>
          {foodType && (foodType?.icon || foodType?.text) && (
            <S.DiningLeftContainer>
              {foodType?.icon && getIconFromName(foodType.icon)}
              {foodType?.text && (
                <S.DiningText dangerouslySetInnerHTML={{__html: foodType?.text}} />
              )}
            </S.DiningLeftContainer>
          )}
          {avgMealCost && (avgMealCost?.icon || avgMealCost?.text) && (
            <S.DiningRightContainer>
              {avgMealCost?.icon && getIconFromName(avgMealCost.icon)}
              {avgMealCost?.text && (
                <S.DiningText dangerouslySetInnerHTML={{__html: avgMealCost.text}} />
              )}
            </S.DiningRightContainer>
          )}
        </S.FirstFullContainer>
        <S.SecondFullContainer>
          {timings && (timings?.icon || timings?.text || timings.details?.length > 0) && (
            <S.DiningLeftContainer>
              {timings?.icon && getIconFromName(timings.icon)}
              <S.DiningText>
                {is24HourFoodAvailiable
                  ? timings?.text
                  : timings?.details &&
                    timings?.details.map((item, index) => (
                      <span key={index.toString()}>
                        <span>{item?.mealType && item?.mealType}</span>{' '}
                        <strong>
                          {item?.start} - {item?.end}
                        </strong>{' '}
                        {index < timings?.details?.length - 1 ? `| ` : ''}
                      </span>
                    ))}
              </S.DiningText>
            </S.DiningLeftContainer>
          )}
          {cuisines && (cuisines?.icon || cuisines?.text) && (
            <S.DiningRightContainer>
              {cuisines?.icon && getIconFromName(cuisines.icon)}
              {cuisines?.text && <S.DiningText dangerouslySetInnerHTML={{__html: cuisines.text}} />}
            </S.DiningRightContainer>
          )}
        </S.SecondFullContainer>
      </S.DiningWrapper>
    </>
  );
};

export default DiningDetailsUI;
